var iphoneType = localStorage.getItem("iphoneType");

document.addEventListener("variant:change", (event) => {
  var variant = event.detail.variant;
  localStorage.setItem("iphoneType", variant.title);
});

var options = document.querySelectorAll(
  ".variant-picker__option .popover__value-list button"
);

setTimeout(function () {
  if (iphoneType != "" || iphoneType != null) {
    options.forEach((option) => {
      var title = option.querySelector("span").textContent;
      if (iphoneType == title) {
        option.click();
      }
    });
  }
}, 1000);


/* Code pour actualiser le texte de disponibilité lorsque l'on change de variante */

async function updateAvailability(section_id) {
  const url = new URL(window.location.href);
  const sectionId = section_id;

  try {
    const response = await fetch(`${url.pathname}?${url.searchParams.toString()}&section_id=${sectionId}`);
    const data = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(data, 'text/html');
    const newAvailabilityText = doc.querySelector('.product-info_availability-text');

    if (newAvailabilityText) {
      document.querySelector('.product-info_availability-text').innerHTML = newAvailabilityText.innerHTML;
    }
  } catch (error) {
    console.error('Error fetching availability information:', error);
  }
}

document.addEventListener("variant:change", async () => {
  const section_id = document.querySelector('variant-picker').dataset.sectionId;
  await updateAvailability(section_id);
});


/* Ouvre le sélecteur de variante quand on clique sur "Choisissez votre modèle" sans iPhone sélectionné */
(function () {
  function initChooseModelHandler() {
    if (localStorage.getItem('iphoneType')) return;

    var productForm = document.querySelector('form[is="product-form"]');
    if (!productForm) return;

    var idInput = productForm.querySelector('input[name="id"]');
    if (!idInput || idInput.value) return;

    var submitBtn = productForm.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    submitBtn.removeAttribute('disabled');

    submitBtn.addEventListener('click', function (e) {
      if (localStorage.getItem('iphoneType')) return;

      e.preventDefault();
      e.stopPropagation();

      var variantSection = document.querySelector('.variant-picker__option');
      var trigger = document.querySelector(
        '.variant-picker__option button[aria-haspopup], .variant-picker__option .popover-trigger, .variant-picker__option summary'
      );

      if (variantSection) {
        variantSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      setTimeout(function () {
        if (trigger) trigger.click();
      }, 350);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChooseModelHandler);
  } else {
    initChooseModelHandler();
  }
})();


/* Clic sur image produit → ouvre la lightbox (mobile < 1000px) */
(function () {
  function initTapToZoom() {
    var gallery = document.querySelector('product-gallery[allow-zoom]');
    if (!gallery) return;

    var zoomBtn = gallery.querySelector('.product-gallery__zoom-button');
    if (!zoomBtn) return;

    gallery.querySelectorAll('.product-gallery__media').forEach(function (media) {
      media.addEventListener('click', function () {
        if (window.innerWidth >= 1000) return;
        zoomBtn.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTapToZoom);
  } else {
    initTapToZoom();
  }
})();
